import { Link } from "react-router-dom";
import ServiceLayout, { ContentSection } from "@/components/site/ServiceLayout";
import { Reveal, TickList } from "@/components/site/Reveal";

const HELP_WITH = [
  "Trauma and PTSD",
  "Anxiety disorders",
  "Phobias",
  "Grief and loss",
  "Performance anxiety",
  "Distressing or intrusive memories",
];

const BENEFITS = [
  "Reduced intensity of traumatic memories and symptoms",
  "Increased emotional resilience",
  "A greater sense of empowerment and self-esteem",
  "Long-lasting change, not just symptom management",
];

export default function Emdr() {
  return (
    <ServiceLayout
      eyebrow="Services"
      title="EMDR Therapy"
      lead="Eye Movement Desensitization and Reprocessing (EMDR) is a highly effective psychotherapy approach that focuses on relieving distress associated with traumatic memories and other adverse life experiences."
      image="/images/emdr-eye.jpg"
      imageAlt="Close-up of a human eye in warm, soft light"
    >
      <ContentSection eyebrow="What it is" title="How EMDR works">
        <Reveal>
          <p className="max-w-3xl text-base sm:text-lg leading-relaxed text-mutedsoft">
            EMDR combines elements of talk therapy with bilateral stimulation — such as eye movements, taps or
            auditory tones — to support the brain's natural healing abilities, allowing traumatic memories and
            related emotions to be processed in a safe and controlled manner.
          </p>
          <p className="mt-4 max-w-3xl text-base sm:text-lg leading-relaxed text-mutedsoft">
            During sessions, you are guided by a trained therapist to access distressing memories while engaging in
            bilateral stimulation. This helps reprocess the memories so new insights, perspectives and adaptive
            beliefs can emerge — reducing the emotional charge of the traumatic event and making room for relief
            and healing.
          </p>
        </Reveal>
      </ContentSection>

      <ContentSection eyebrow="What it can help with" title="Beyond trauma" pale>
        <TickList items={HELP_WITH} />
        <div className="mt-12">
          <TickList items={BENEFITS} />
        </div>
        <Reveal delay={0.1}>
          <p className="mt-10 max-w-3xl text-base leading-relaxed text-mutedsoft">
            EMDR addresses the underlying causes of distress rather than only managing symptoms, helping you
            integrate difficult experiences into your life story and move forward with a renewed sense of
            well-being.
          </p>
        </Reveal>
      </ContentSection>

      <ContentSection eyebrow="Fees & funding" title="Accessing EMDR">
        <Reveal>
          <p className="max-w-3xl text-base sm:text-lg leading-relaxed text-mutedsoft">
            EMDR sessions are <span className="font-semibold text-charcoal">$200 per 50-minute session</span>. Our
            therapeutic interventions can be provided to NDIS participants or to individuals on a Mental Health
            Treatment Plan, which attracts a <span className="font-semibold text-charcoal">Medicare rebate of
            $89.50</span>. See{" "}
            <Link to="/fees-funding" className="font-semibold text-euca hover:underline" data-testid="emdr-fees-link">
              Fees &amp; Funding
            </Link>{" "}
            for details.
          </p>
        </Reveal>
      </ContentSection>
    </ServiceLayout>
  );
}
